import { modalHeaderStyles } from './modal-header.styles'

export const ModalHeader = ({ children }: { children?: React.ReactNode }) => {
  return <div className={modalHeaderStyles()}>{children}</div>
}
